import React from "react";
import {Button, Columns, Form, Modal, Section, Table} from "react-bulma-components";
import ApprovalModalRow from "./ApprovalModalRow";



export default function ApprovalModal({open, setOpen, invoices, onApprove, setSelected, onSave, nominalCodes, trackingOptions,
                                          nominalObjects, trackingObjects, onReadyToApprove, view}){

    const getInvoiceTotal = () => {
        // This does not work at all as invoices is an object not array
        let vat_total = invoices.reduce((accumulator, current) => accumulator + current.amount, 0);
        let no_vat_total = invoices.reduce((accumulator, current) => accumulator + current.no_vat_amount, 0);
        return vat_total + no_vat_total;
    };



    const onChange = (e, key) => {
        let newInvoices = {...invoices};
        newInvoices[key][e.target.name] = e.target.value;
        setSelected(newInvoices);
    }

    const onNominalChange = (e, key) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: nominalObjects[e.target.value]
            }
        }
        onChange(toUpdate, key);
    }

    const onTrackingChange = (e, key) =>{
        const toUpdate = {
            target: {
                name: e.target.name,
                value: trackingObjects[e.target.value]
            }
        };
        onChange(toUpdate, key);
    }

    const handleApprove = () => {
        // manipulate invoices list so that its an array of objects not an object of objects
        let data = handleData(invoices)
        onApprove(data);
        setOpen(false);
    }

    const handleReady = () => {
        let data = handleData(invoices);
        onReadyToApprove(data);
        setOpen(false)
    }

    const handleData = (data) => {
        let newDataArray = []
        Object.keys(data).forEach(key => {
            newDataArray.push(invoices[key]);
        })
        return newDataArray
    }

    return (
        <Modal
          closeOnBlur
          show={open}
          onClose={() => {
            setOpen(false);
          }}
        >
          <Modal.Content className={"wider-modal"}>
            <Section style={{ backgroundColor: "white" }}>
                <Columns>
                    <Columns.Column>
                        <Form.Label>Total Invoice Amount</Form.Label>
                        <Form.Input
                            disabled={true}
                            value={0}
                        />
                    </Columns.Column>
                    <Columns.Column></Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"}>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Invoice Date</th>
                                    <th>Nominal Code</th>
                                    <th>No VAT Nominal Code</th>
                                    <th>Amount (£)</th>
                                    <th>No VAT Amount (£)</th>
                                    <th>Tracking Category</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                            {Object.keys(invoices).map(key => (
                                <ApprovalModalRow
                                    Objkey={key}
                                    invoice={invoices[key]}
                                    onChange={onChange}
                                    onSave={onSave}
                                    nominalCodes={nominalCodes}
                                    trackingOptions={trackingOptions}
                                    onNominalChange={onNominalChange}
                                    onTrackingChange={onTrackingChange}
                                />
                            ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"danger"}
                            fullwidth
                            onClick={() => setOpen(false)}
                        >
                            Cancel
                        </Button>
                    </Columns.Column>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            fullwidth
                            onClick={view === "ready" ? handleApprove : handleReady}
                        >
                            {view === "ready" ? "Approve" : "Ready to Approve"}
                        </Button>
                    </Columns.Column>
                </Columns>
            </Section>
          </Modal.Content>
        </Modal>
    )


}